import {FIELD_NAMES} from "profile/enums";
import {IWorkDetailsFields} from "IncompleteInfoV2/WorkDetails/index";
import {IResidenceAddressFields} from "IncompleteInfoV2/ResidenceAddress/index";
import {regex} from "profile/regex";
import {IValidMinMax} from "IncompleteInfoV2/interface";
import {IBankAccountProfile, ILoanProfile} from "IncompleteInfoV2/LoanRequest/utils";
import {diffYears} from "utils";
import {IReferenceDetails, IReferences} from "IncompleteInfoV2/References/index";

const selectFieldTypes: string[] = [
    FIELD_NAMES.RES_TENURE,
    FIELD_NAMES.RESIDENT_TYPE,
    FIELD_NAMES.EMPLOYER_TYPE,
    FIELD_NAMES.CURRENT_EMPLOYER,
    FIELD_NAMES.PURPOSE,
];

const dateFields: string[] = [
    FIELD_NAMES.DOB,
    FIELD_NAMES.RES_TENURE,
    FIELD_NAMES.DURATION,
];

const minMaxValidation = (identifier: string, value: string | number, minMax: IValidMinMax) => {
    if (dateFields.includes(identifier)) {
        value = ((diffYears(new Date(), new Date(value))));
    }
    return (value < minMax[identifier].min || value > minMax[identifier].max);
};

export const validations = (
    fields: IResidenceAddressFields | IWorkDetailsFields | IBankAccountProfile | ILoanProfile | IReferences |
    IReferenceDetails,
    minMax?: IValidMinMax,
) => {
    const errors = {};
    for (const key in fields) {
        if (!fields[key]) {
            errors[key] = `Please ${selectFieldTypes.includes(key) ? "select" : "enter"} this to continue the application`;
        } else if (regex[key] && !new RegExp(regex[key]).test(fields[key])) {
            errors[key] = "Please enter correct details to continue the application ";
        } else if (minMax && minMax[key] && (minMaxValidation(key, fields[key], minMax))) {
            errors[key] = `Please enter ${key.toLowerCase()} ${minMax[key]["min"] && minMax[key].max ?
                ` between ${minMax[key].min} and ${minMax[key].max}` : `${minMax[key]["min"] ?
                    `minimum ${minMax[key]["min"]}` : `maximum ${minMax[key]["max"]}`}`}`;
        }
    }
    return errors;
};
